import { selectDraft, selectExternalUsers, selectInternalUsers } from '@/store/selectors/createSix';
import { setDraftField, setHasPendingExternalManualEntries } from '@/store/slices/createSix/createSixSlice';
import { useExternalInvitationsAdapter } from '@/hooks/shared/useExternalInvitationsAdapter';

export function useStepExternalInvitations() {
  return useExternalInvitationsAdapter({
    selectDraft,
    selectInternalUsers,
    selectExternalUsers,
    dispatchSetExternalParticipantIds: (dispatch, value) =>
      dispatch(setDraftField({ key: 'externalParticipantIds', value })),
    dispatchSetNewExternalUsers: (dispatch, value) =>
      dispatch(setDraftField({ key: 'newExternalUsers', value })),
    dispatchSetHasPendingEntries: (dispatch, value) =>
      dispatch(setHasPendingExternalManualEntries(value)),
  });
}
